import * as React from 'react';
import * as Strings from './Strings';
import { ListGroup, ListGroupItem } from 'react-bootstrap';

interface IProps {
    disabled: boolean;
    commonTexts: string[];
    listId: string;
}

const PlanAnnotationTextPanel = (props: IProps) => {
    return (
        <div className="text-panel" id={props.listId}>
            <ListGroup>
                {[]
                    .concat(props.commonTexts)
                    .sort()
                    .map((x, index) => (
                        <ListGroupItem
                            key={'texts-' + index}
                            draggable={!props.disabled}
                            className={Strings.textPanelItemClassName}
                            disabled={props.disabled}
                        >
                            {x}
                        </ListGroupItem>
                    ))}
            </ListGroup>
        </div>
    );
};

export default PlanAnnotationTextPanel;
